import { sqliteTable, text, integer, index } from "drizzle-orm/sqlite-core";
import { users } from "./users";

// ============================================================================
// document_versions — เก็บ snapshot ทุกครั้งที่แก้ไข document
// ============================================================================
export const documentVersions = sqliteTable("core_document_versions", {
  id: text("id").primaryKey(), // ULID
  companyId: text("company_id").notNull(),

  module: text("module").notNull(), // module ที่เกี่ยวข้อง
  doctype: text("doctype").notNull(), // ชื่อ doctype (e.g. "booking", "invoice")
  documentId: text("document_id").notNull(), // ID ของ document

  version: integer("version").notNull(), // 1, 2, 3... auto-increment per document
  snapshot: text("snapshot").notNull(), // JSON: full record data at this version
  changes: text("changes"), // JSON: { field: { old, new } } — field-level diff

  // Context
  action: text("action").notNull(), // "created", "updated", "state_changed", "rollback"
  summary: text("summary"), // สรุปสั้นๆ เช่น "แก้ไขราคา จาก 900 เป็น 1000"

  createdAt: text("created_at").notNull(),
  createdBy: text("created_by").notNull().references(() => users.id),
}, (table) => [
  index("idx_document_versions_doc").on(table.companyId, table.module, table.doctype, table.documentId),
]);

// Type exports
export type DocumentVersion = typeof documentVersions.$inferSelect;
export type NewDocumentVersion = typeof documentVersions.$inferInsert;
